<template>
  <div class="appcenter">
    <!-- <span class="tasktitle">{{ MenuName }}</span> -->
    <div class="fullheight">
    <el-container>
      <el-aside width="120px" v-if="!$route.meta.single" class="app_center_aside">
        <el-card shadow="never" :style="conheight">
          <!-- <div slot="header" class="clearfix">
            <b class="top-title">{{ currentMenu.name }}</b>
          </div> -->
          <el-menu :default-active="activeMenuIndex" unique-opened>
            <template v-for="menu in menus">
              <el-menu-item
                v-if="!menu.children || menu.children.length == 0"
                :key="menu.id"
                :index="menu.id"
                @click.native="handleSelect(menu)"
                class="el-submenu__title_x7"
                >{{ menu.name }}</el-menu-item
              >
              <el-submenu v-else :key="menu.id" :index="menu.alias">
                <template slot="title">{{ menu.name }}</template>
                <template v-if="menu.children && menu.children.length > 0">
                  <el-menu-item
                    v-for="item in menu.children"
                    :key="item.id"
                    :index="item.id"
                    @click.native="handleSelect(item)"
                    >{{ item.name }}</el-menu-item
                  >
                </template>
              </el-submenu>
            </template>
          </el-menu>
        </el-card>
      </el-aside>

      <!-- <el-tabs v-model="activeName" @tab-click="handleClick" >
        <template v-for="menutitle in menus">
          <el-tab-pane :label="menutitle.name" :name="menutitle.alias" :key="menutitle.id" :style="X7Height" >
              <div v-for ="title in titlesBack" :key="title.id">
                <p style="font-size: 14px;font-family: PingFang SC-Semibold, PingFang SC;font-weight: 600;color: #292B44;margin-top: 16px;" v-if="title.apps.length>0">{{title.name}}</p>
                <app-main :apps="title.apps" :pageResult="pageResult"></app-main>
              </div>
          </el-tab-pane>
        </template>
      </el-tabs> -->

      <el-main class="tab-container">
        <el-tabs
          v-model="activeTab"
          @tab-click="tabClick"
          class="fullheight"
          v-if="tabs.length > 0"
        >
          <el-tab-pane
            v-for="tab in tabs"
            :key="tab.id"
            :label="tab.name"
            :name="tab.id"
          >
            <app-main :apps="apps" :pageResult="pageResult"></app-main>
          </el-tab-pane>
        </el-tabs>
        <app-main :apps="apps" :pageResult="pageResult" v-else></app-main>
      </el-main>
    </el-container>
  </div>
  </div>
</template>

<script>
import portal from "@/api/portal.js";
import appMain from "@/components/appCenter/AppMain.vue";
import { mapState } from "vuex";
export default {
  name: "app-center",
  components: {
    appMain,
  },
  data() {
    return {
      activeName:"",
      apps: [],
      pageResult: {
        page: 1,
        pageSize: 24,
        total: 0,
      },
      menus: [],
      activeMenuIndex: "",
      activeTab: "",
      tabs: [],
      titles:[],
      titlesBack:[],
      MenuName:"",
      X7Height:{ height: window.innerHeight * 0.822 + "px",overflow: "auto" },
      conheight: { height: window.innerHeight -48 + "px"},      
    };
  },
  computed: mapState({
    currentMenu: (state) => state.menu.currentMenu,
  }),
  mounted() {
    this.MenuName = sessionStorage.MenuName;
    // let menu_alias = this.getQueryString("menu");
    let menu_alias = this.$route.query.menu;
    portal.getSubMenus("appCenterFront", (resp) => {
      this.menus = resp.data.value;
      if(resp.data.value.length>0){
        this.activeName = resp.data.value[0].alias;
        this.handleClick({name:this.activeName},null);
      }
      this.selectFirstOne();
    });

  },
  methods: {
    initApps(){
      for(let i=0;i<this.titles.length;i++){
        let param = {menuId: this.titles[i].id};
        this.titles[i].apps=[];
        portal.getSysAppList(param).then((data) => {
          this.titles[i].apps=data;
          // console.log(this.titles[i]);
          this.titlesBack.push(this.titles[i]);
        })
      }
    },
    handleClick(tab, event) {//获取具体菜单图标
      this.titlesBack=[];//初始化app
      portal.getSubMenus(tab.name, (resp) => {
        this.titles = resp.data.value;
        this.initApps();
      })
    },
    getQueryString(name) {
        let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
        let r = window.location.search.substr(1).match(reg);
        if (r != null) {
            return unescape(r[2]);
        }
        return null;
    },
    //加载应用数据
    loadData(menuId) {
      // let param = {
      //   pageBean: this.pageResult,
      //   querys: [
      //     {property: "is_publish_", value: '1', group: "main", operation: "EQUAL", relation: "AND"},
      //     {property: "menu_id_", value: menuId, group: "main", operation: "EQUAL", relation: "AND",}],
      //   sorter:[{direction: 'ASC',property: 'sn_'}]
      // }
      let param = {
        menuId: menuId,
      };
      portal.getSysAppList(param).then((data) => {
        this.apps = data;
      });
    },
    handleSelect(data) {
      this.$set(this, "tabs", data.children);
      if (this.tabs.length <= 0) {
        this.loadData(data.id);
        return;
      }
      this.loadData(this.tabs[0].id);
      this.activeTab = this.tabs[0].id;
    },
    tabClick(tab) {
      this.loadData(tab.name);
    },
    getFirstMenu(menus,index) {
      if (menus[0].children && index<2) {
        index++;
        return this.getFirstMenu(menus[0].children);
      }else {
        return menus[0];
      }
    },
    selectFirstOne() {
      if (this.menus && this.menus.length>0) {
        let menu = this.getFirstMenu(this.menus, 1);
        this.activeMenuIndex = menu.id;
        this.handleSelect(menu);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";

/deep/ .fullheight{
  background: #ffffff !important;
  border-radius: 2px;
}

/deep/ .base-main{//隐藏首页滚动条
  overflow:hidden;
}

/deep/ .tasktitle{
  height: 54px;
  line-height: 54px;
  font-size: 14px;
  font-family: PingFang SC-Semibold, PingFang SC;
  font-weight: 600;
  color: #292B44;
}

.top-title {
  line-height: 30px;
  // margin-left: 20px;
  font-size: 14px;
  color: #333;
}
/deep/ .el-main {
  padding: 16px 16px 0px 16px !important;
  background:#F0F2F5 !important;
}
.el-card {
  background-color: transparent;
  border: 0px;
}
.el-card /deep/ .el-card__header {
  height: 48px;
  border-bottom: 1.5px solid #dedede;
  color: #a2a2a2;
}
.el-card /deep/ .el-card__body {
  padding: 0;
}
.menu-ul {
  list-style: none;
  margin: 0;
  padding-left: 0;
}
.menu-ul > li {
  padding: 10px 0 10px 0;
  height: 30px;
  line-height: 30px;
  list-style: none;
  cursor: pointer;
  white-space: nowrap;
  border-bottom: 1px solid #dfdfdf;
}
.menu-ul > li:last-child {
  border-bottom: 0;
}
.menu-ul > li > a {
  color: $--color-text-regular;
  padding: 2px 5px 2px 17px;
  border-left: 2px solid transparent;
  text-decoration: none;
}
.menu-ul > li > a:hover {
  color: $--theme-color;
}
.menu-ul > li > a.router-link-active {
  border-left: 2px solid $--theme-color;
  color: $--theme-color;
}
.el-menu,
/deep/ .el-menu {
  background-color: transparent;
  border-right: none;
}

/deep/ .el-submenu .el-menu-item{
  min-width:120px;
  max-width:120px;
  overflow:hidden;/*内容超出后隐藏*/
  text-overflow: ellipsis;/* 超出内容显示为省略号 */
  white-space: nowrap;/* 文本不进行换行 */
}
/deep/ .el-menu-item {
  margin: 8px 0px 0px 0px !important;
  height: 44px !important;
  line-height: 44px !important;
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #52535E !important;
  padding: 0px 24px 0px 24px !important;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
}
/deep/ .el-menu-item.is-active{
    position: relative !important;
    color:#1890FF !important;
    background: #E4F6FF !important;
    &::before{
      position: absolute;
      content: "";
      width: 4px;
      background:#188DFA;
    }
  }
  /deep/ .el-menu-item:hover{
    background: #EDF6FB !important;
  }
/deep/  .el-submenu{
    padding-top: 8px !important;
    .el-menu-item.is-active{
      &::before{
        left:0px !important;
        top: 0px !important;
        height: 44px !important;
      }
    }
  }
/deep/ div.el-submenu__title {
  height: 44px;
  line-height: 44px;
  font-size: 14px;
  font-family: PingFang SC-Semibold, PingFang SC;
  font-weight: 600;
  color: #292B44;
  padding: 0px 16px 0px 16px !important;
}
/deep/ .el-submenu__title_x7.is-active{
    position: relative !important;
    color:#1890FF !important;
    &::before{
      position: absolute !important;
      content: "" !important;
      width: 4px !important;
      background:#188DFA !important;
      left:0px !important;
      top: 0px !important;
      height: 44px !important;
    }
  }
/deep/ .el-submenu__title_x7{
  height: 44px !important;
  line-height: 44px !important;
  font-size: 14px !important;
  font-family: PingFang SC-Semibold, PingFang SC !important;
  font-weight: 600 !important;
  color: #292B44 !important;
  padding: 0px 16px 0px 16px !important;
  margin: 8px 0px 0px 0px !important;
}


/deep/ i.el-submenu__icon-arrow {
  position: absolute;
  top: 50%;
  right: 16px;
  margin-top: -7px;
  -webkit-transition: -webkit-transform 0.3s;
  transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
  font-size: 12px;
}

/deep/ .el-tabs__header {
  padding: 8px 0px 0px 0px !important;
  margin:0px !important;
}
/deep/ .el-tabs__content{
    background: #ffffff;
}

/deep/ .el-tabs{
  padding-left: 24px;
}
</style>
